import { BaseError } from '~domain/error/base-error';
import { ClientErrorWithStatus } from '~domain/error/client-error';
import { ErrorTypes } from '~domain/error/error-types';

export function formatErrorMessage(e: any): string {
  return e instanceof Error ? e.toString() : 'unknown';
}

export function isErrorTypeOf(input: any, expectedType: any): boolean {
  // All our custom errors has a `type` field that determined the actual real error
  if (!input || input.type == undefined) {
    return false;
  }

  return (input as BaseError).type === expectedType;
}

export function isBadRequestError(input: Error) {
  return isClientRequestError(input) && isErrorStatusCode(input as ClientErrorWithStatus, 400);
}

export function isClientRequestError(input: Error) {
  return isErrorTypeOf(input, ErrorTypes.CLIENT_REQUEST_ERROR);
}

export function isConflictClientError(input: Error) {
  return isClientRequestError(input) && isErrorStatusCode(input as ClientErrorWithStatus, 409);
}

function isErrorStatusCode(error: ClientErrorWithStatus, expectedStatusCode: number) {
  return error.statusCode === expectedStatusCode;
}

export function isNotFoundClientError(input: Error) {
  return isClientRequestError(input) && isErrorStatusCode(input as ClientErrorWithStatus, 404);
}

export function isUnauthorizedClientError(input: Error) {
  return isClientRequestError(input) && isErrorStatusCode(input as ClientErrorWithStatus, 401);
}
